export class ListResourceAggregateUserPermissionError extends Error {
    
}